import { isPlaceholderProfilePictureUrl } from '@wlb/shared/utils/imageUrl';

/**
 * Normalises the shared `ImageSource | string | null` avatar shape to a URL.
 *
 * Known API placeholder profile pictures (defaultphoto.gif, /profilepictures/
 * default) are treated as no avatar so the caller renders the deterministic
 * letter fallback — the same filter the Profile screen applies via
 * `getProfileAvatarUrl`. Without this, a user who never uploaded a photo
 * shows a broken image instead of their initial.
 */
export function resolveAvatarSrc(avatar: unknown): string | null {
  if (!avatar) return null;
  if (typeof avatar === 'string') {
    const trimmed = avatar.trim();
    return trimmed && !isPlaceholderProfilePictureUrl(trimmed) ? trimmed : null;
  }
  if (typeof avatar === 'object' && 'uri' in avatar) {
    const uri = (avatar as { uri?: string }).uri;
    if (typeof uri !== 'string' || !uri.trim()) return null;
    return isPlaceholderProfilePictureUrl(uri) ? null : uri.trim();
  }
  return null;
}

